import React from 'react';
import PropTypes from 'prop-types';

import { UncontrolledTable } from '~/components';

const DocTable = ({
  columns,
  defaultSorted,
  params,
  ...rest
}) => (
  <UncontrolledTable
    name="patient-docs"
    endpoint={{
      url: 'data/public/patient-attachment',
      params,
    }}
    columns={columns}
    defaultSorted={defaultSorted}
    {...rest}
  />
);

DocTable.propTypes = {
  params: PropTypes.shape(),
  columns: PropTypes.arrayOf(PropTypes.shape()),
  defaultSorted: PropTypes.arrayOf(PropTypes.shape()),
};

DocTable.defaultProps = {
  params: {},
  columns: [{
    id: 'attachmentTitle',
    Header: 'Title',
    accessor: 'attributes.attachmentTitle',
  }, {
    id: 'attachmentDescription',
    Header: 'Description',
    accessor: 'attributes.attachmentDescription',
  }, {
    id: 'attachmentType',
    Header: 'File Type',
    accessor: 'attributes.attachmentType',
  }, {
    id: 'createdDate',
    Header: 'Created Date',
    accessor: 'attributes.createdDate',
    cellType: 'date',
  }, {
    id: 'author',
    Header: 'Author',
    accessor: 'attributes.author',
  }],
  defaultSorted: [{ id: 'createdDate', desc: true }],
};

export default DocTable;
